var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-agenda",
    attrs: {
      isCustomizable: _vm.settings.isCustomizable,
      loading: _vm.loading,
      placeholder: _vm.placeholder,
      placeholderImg: "/ressources/logged/img/dashboard/dashboard-calendar.svg",
      error: _vm.error
    },
    on: {
      "edit-card": _vm.toggleSettingsForm,
      "hide-card": function($event) {
        return _vm.$emit("hide-card", _vm.type)
      },
      "refresh-card": function($event) {
        return _vm.fetchCard(_vm.type, {}, true)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function() {
          return [
            _c("CompassIconButton", {
              attrs: {
                icon: "plus",
                onclick:
                  "Activities.openActivityForm(null, null, null, null, 'event')"
              }
            }),
            _vm._v(" "),
            _c(
              "portal",
              { attrs: { to: "dashboardSettingsForm" } },
              [
                _vm.showSettingsForm
                  ? _c("card-setting-overlay", {
                      attrs: {
                        formName: _vm.settingsFormName,
                        cardCustomSettings: _vm.customSettings,
                        cardName: _vm.type,
                        cardSettings: _vm.settings
                      },
                      on: {
                        fetched: _vm.fetchCard,
                        "close-form": _vm.toggleSettingsForm,
                        "custom-settings-saved": function($event) {
                          return _vm.fetchCard(_vm.type, {}, true)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            (_vm.cardData && _vm.cardData.length > 0) ||
            (_vm.cardData && _vm.cardData.error)
              ? _c("div", { staticClass: "flex-column" }, [
                  !_vm.cardData.error
                    ? _c(
                        "div",
                        [
                          _vm._l(_vm.eventsByDays, function(eventsDay, index) {
                            return _c(
                              "div",
                              { key: "" + index },
                              [
                                eventsDay.length > 0
                                  ? [
                                      _c("header", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "grey ml-2 my-2 acenter line-behind"
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$filters.dateFormatter(
                                                      _vm
                                                        .moment()
                                                        .add(index, "days")
                                                        .unix(),
                                                      "NORMAL_DATE",
                                                      true
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ])
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        _vm._l(eventsDay, function(event) {
                                          return _c(
                                            "li",
                                            {
                                              key: event.id,
                                              staticClass: "event mb-1",
                                              style: {
                                                backgroundColor: _vm.calendarColor(
                                                  event
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.eventDetail(event)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: {
                                                    "gray-60": _vm.isLate(
                                                      event.end
                                                    )
                                                  },
                                                  style: {
                                                    borderColor: _vm.labelColor(
                                                      event
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "details" },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "lab gray-60"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                event.label
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                event.title
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  event.relateds
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ml-2 mt-1"
                                                        },
                                                        [
                                                          event.relateds[0]
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "link regular gray-60 fs-2",
                                                                  attrs: {
                                                                    href:
                                                                      event
                                                                        .relateds[0]
                                                                        .relatedlink
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                            " +
                                                                      _vm._s(
                                                                        event
                                                                          .relateds[0]
                                                                          .relatedname
                                                                      ) +
                                                                      "\n                                        "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          event.relateds[1]
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "link regular gray-60 fs-2 ml-3",
                                                                  attrs: {
                                                                    href:
                                                                      event
                                                                        .relateds[1]
                                                                        .relatedlink
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                            " +
                                                                      _vm._s(
                                                                        event
                                                                          .relateds[1]
                                                                          .relatedname
                                                                      ) +
                                                                      "\n                                        "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "time" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "gray-60"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.dateCase(
                                                                event
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "link acenter dd mt-4",
                              attrs: { href: "/?_f=agenda" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$l10n.__("Voir tous les événements"))
                              )
                            ]
                          )
                        ],
                        2
                      )
                    : _c("div", [
                        _c("div", { staticClass: "alert alert-danger" }, [
                          _vm._v(_vm._s(_vm.cardData.error))
                        ])
                      ])
                ])
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }